import React, { createContext, useReducer, useContext } from "react";
import { loadPendingReports, savePendingReports } from "../../../screens/portfolioApp/portfolio/commonApis";

const DrawerContext = createContext();

const initialState = {
  valuationName: "",
  drawerVisible: false,
  steps_menu: 0,
  currentStep: 1,
  haveError: false,
  isInstantReport: false,
  saveForm: {
    status: false,
    step: 0,
    prevStep: 0,
  },
  configLastDate: 0,
  SET_Dealer_Info_Id: "",
  latlong: {
    cen_lat: "",
    cen_long: "",
  },
  UserAgreedWithMultiple: "",
  header_height: 0,
  valuation: "",
  dealerCR: "",
  isComputed: "",
  portfolioName: "",
  CalculationConfig: null,
  valuationConfig: "",
  portfolioData: "",
  portfolioCols: "",
  dataLoading: "",
  singleDealer: {},
  previousFeedbacks: [],
  loadingFeedbacks: false,
  // AI Analytics report generation tracking - load from localStorage
  pendingReports: loadPendingReports(),
};

const reducer = (state, action) => {
  switch (action.type) {
    case "OPEN_DRAWER":
      return { ...state, drawerVisible: true };
    case "SET_STEP":
      return { ...state, currentStep: action.value };
    case "CLOSE_DRAWER":
      return { ...state, drawerVisible: false };
    case "UPDATE_STEP":
      return { ...state, steps: action.value };
    case "UPDATE_PAYLOAD_DB":
      return { ...state, saveForm: action.value };
    case "SET_ERROR_SC3":
      return { ...state, haveError: action.value };
    case "SET_CONFIG_LAST_DATE":
      return { ...state, configLastDate: action.value };
    case "SET_Dealer_Info_Id":
      return { ...state, SET_Dealer_Info_Id: action.value };
    case "SET_LAT_LONG":
      return { ...state, latlong: action.value };
    case "YOUR_MULTIPLE":
      return { ...state, UserAgreedWithMultiple: action.value };
    case "SET_HEADER_HEIGHT":
      return { ...state, header_height: action.value };
    case "SET_VALUATION_NAME":
      return { ...state, valuationName: action.value };
    case "SET_INSTANT_REPORT":
      return { ...state, isInstantReport: action.value };
    case "SET_VALUATION":
      return { ...state, valuation: action.value };
    case "SET_PORTFOLIO_NAME":
      return { ...state, portfolioName: action.value };
    case "SET_PORTFOLIO_DATA":
      return { ...state, portfolioData: action.value };
    case "SET_PORTFOLIO_COLS":
      return { ...state, portfolioCols: action.value };
    case "DEALER_CURRENT_RADIUS":
      return { ...state, dealerCR: action.value };
    case "IS_COMPUTED":
      return { ...state, isComputed: action.value };
    case "SET_CALCULATION_CONFIG":
      return { ...state, CalculationConfig: action.value };
    case "VALUATION_CONFIG":
      return { ...state, valuationConfig: action.value };
    case "DATA_LOADING":
      return { ...state, dataLoading: action.value };
    case "SINGLE_DEALER":
      return { ...state, singleDealer: action.value };
    case "SET_PREVIOUS_FEEDBACKS":
      return { ...state, previousFeedbacks: action.value };
    case "SET_LOADING_FEEDBACKS":
      return { ...state, loadingFeedbacks: action.value };
    case "ADD_PENDING_REPORT":
      // When adding a new pending report, remove any existing ready reports
      // and add the new pending report
      const filteredReports = state.pendingReports.filter(report => report.status !== "ready");
      const newReportsAdd = [...filteredReports, action.value];
      savePendingReports(newReportsAdd);
      return { 
        ...state, 
        pendingReports: newReportsAdd
      };
    case "UPDATE_PENDING_REPORT":
      const newReportsUpdate = state.pendingReports.map(report =>
        report.id === action.value.id ? { ...report, ...action.value } : report
      );
      savePendingReports(newReportsUpdate);
      return {
        ...state,
        pendingReports: newReportsUpdate
      };
    case "REMOVE_PENDING_REPORT":
      const newReportsRemove = state.pendingReports.filter(report => report.id !== action.value);
      savePendingReports(newReportsRemove);
      return {
        ...state,
        pendingReports: newReportsRemove
      };
    case "CLEAR_PENDING_REPORTS":
      savePendingReports([]);
      return { ...state, pendingReports: [] };
    default:
      return state;
  }
};

const DrawerProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <DrawerContext.Provider value={{ state, dispatch }}>
      {children}
    </DrawerContext.Provider>
  );
};

const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error("useDrawer must be used within a DrawerProvider");
  }
  return context;
};

export { DrawerProvider, useDrawer };
